import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询敏感词列表
export function queryByCondition(data) {
  return request({
    url: URL.mdm.sensitiveWord.queryByCondition,
    method: 'post',
    data
  })
}

// 查询所有敏感词
export function queryAll() {
  return request({
    url: URL.mdm.sensitiveWord.queryAll,
    method: 'post'
  })
}

// 保存敏感词
export function saveBatch(data) {
  return request({
    url: URL.mdm.sensitiveWord.saveBatch,
    method: 'post',
    data
  })
}

// 删除敏感词
export function removeBatch(data) {
  return request({
    url: URL.mdm.sensitiveWord.removeBatch,
    method: 'post',
    data
  })
}

// 分割敏感词
export function splitSensitiveWord(data) {
  return request({
    url: URL.mdm.sensitiveWord.splitSensitiveWord,
    method: 'post',
    data
  })
}

// 邮件提醒
export function sendEmailSensitiveWord(data) {
  return request({
    url: URL.mdm.sensitiveWord.sendEmailSensitiveWord,
    method: 'post',
    data
  })
}

// 敏感词录入
export function saveSensitiveWord(data) {
  return request({
    url: URL.mdm.sensitiveWord.saveSensitiveWord,
    method: 'post',
    data
  })
}

// 敏感词 编辑保存
export function save(data) {
  return request({
    url: URL.mdm.sensitiveWord.save,
    method: 'post',
    data
  })
}

// 校验敏感词
export function checkSensitiveWord(data) {
  return request({
    url: URL.mdm.sensitiveWord.checkSensitiveWord,
    method: 'post',
    data
  })
}
